import { getAppConfig } from '@services/config';

import type { Product } from '@app-types/product';

const appConfig = getAppConfig();

export const productsSkeleton: Product[] = Array.from({ length: 12 }, (_, index) => {
    return {
        id: `bytel-${index}`,
        urlKey: `bytel-${index}`,
        gencode: 'bytel',
        url: 'https://wwww.bouyguestelecom.fr',
        brand: 'Bouygues',
        name: 'Telecom',
        priceInfo: { top: "Jusqu'à", unit: '€' },
        price: 0,
        recommended: false,
        hasCashbackOffer: true,
        image: `${appConfig.assets.cmsImages.url}/original/image/CMS/ecommerce/wall/lazyload-phone-default-image.svg`,
        details: {
            price: {
                initial: 0,
                final: 0,
                forever: 0,
            },
            fundings: [],
            discounts: [],
        },
        colors: [],
        hasFunding: true,
        availableCnc: false,
        inStock: true,
        products: [],
        categories: [],
    };
});

export const odrSkeleton: Product[] = Array.from({ length: 28 }, (_, index) => {
    return {
        id: `bytel-${index}`,
        urlKey: `bytel-${index}`,
        gencode: 'bytel',
        url: 'https://wwww.bouyguestelecom.fr',
        brand: 'Bouygues',
        name: 'Telecom',
        priceInfo: { top: "Jusqu'à", unit: '€' },
        price: 0,
        recommended: false,
        hasCashbackOffer: true,
        image: `${appConfig.assets.cmsImages.url}/original/image/CMS/ecommerce/wall/lazyload-accessory-default-image.svg`,
        details: {
            price: {
                initial: 0,
                final: 0,
                forever: 0,
            },
            fundings: [],
            discounts: [],
        },
        header: 'Lorem ipsum dolor',
        colors: [],
        hasFunding: true,
        availableCnc: false,
        inStock: true,
        products: [],
        categories: [],
    };
});
